import React from "react";
import notification from "antd/lib/notification";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";

const loadingIcon = <LoadingOutlined style={{ marginLeft: 10 }} />;
const style = {
  zIndex: 9999,
};

export const notificationSuccess = (description) => {
  notification["success"]({
    message: "SUCCÈS",
    description,
    style,
  });
};

export const notificationError = (description) => {
  notification["error"]({
    message: "ERREUR",
    duration: 0,
    description,
    style,
  });
};

export const notificationWarning = (description) => {
  notification["warning"]({
    message: "ATTENTION",
    description,
    style,
  });
};

export const notificationInfo = (
  description,
  key,
  duration = 4.5,
  loading = false
) => {
  const nodeDescription = (
    <div>
      {description} {loading && loadingIcon}
    </div>
  );
  notification["info"]({
    message: "INFORMATION",
    description: nodeDescription,
    key,
    duration,
    style,
  });
};

export const closeNotification = (key) => notification.close(key);
